<template>
  <v-container
    id="caderno-servicos-historico"
    fluid
    tag="section"
  >
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-file-compare"
          inline
          class="ml-0 px-5 py-4"
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Caderno de Serviços
            </div>
          </template>

          <v-btn
            id="btn-novo-caderno-servicos"
            color="success"
            dark
            elevation="1"
            class="mt-5"
            style="float:left"
            relative
            text
            medium
            @click="$router.push(`edit`)"
          >
            <v-icon
              left
              size="30px"
            >
              mdi-plus-circle
            </v-icon>
            Novo Relatório
          </v-btn>

          <v-text-field
            id="caderno-servicos-historico-search"
            v-model="search"
            append-icon="mdi-magnify"
            class="break-search bs-caderno-servicos ml-auto mt-4"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px;"
          />

          <general-progress-bars
            class="mt-11"
            :items="downloadProgressData"
            prefix-text="Baixando Caderno de Serviços"
          />

          <v-divider class="mt-10" />

          <v-data-table
            class="caderno-servicos-table"
            :headers="headers"
            :items="cadernos"
            :search.sync="search"
            :header-props="{
              sortByText: 'Ordenar Por'
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página'
            }"
            no-data-text="Nenhum Caderno de Serviços disponível"
            no-results-text="Nenhum registro correspondente encontrado"
            mobile-breakpoint="800"
          >
            <template v-slot:[`item.id`]="{ item }">
              {{ item.id }}
            </template>
            <template v-slot:[`item.nome`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="text-truncate-column"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.nome }}
                  </div>
                </template>
                <span>{{ item.nome }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.usuario`]="{ item }">
              {{ item.usuario }}
            </template>
            <template v-slot:[`item.executed`]="{ item }">
              {{ item.executed }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <general-status :status="item.status" />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                id="action-download-caderno-servicos"
                :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
                :disabled="item.status != 'SUCESSO'"
                color="gray"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                :loading="
                  downloadProgressData[item.id] !== undefined ? true : false
                "
                @click="downloadItem(item)"
              >
                <v-icon small>
                  mdi-download
                </v-icon>
              </v-btn>
              <v-menu 
                v-if="item.status == 'SUCESSO' || canRunItem(item) || canDeleteItem(item)"
                offset-y
                right
              >
                <template 
                  v-slot:activator="{ on, attrs }"
                >
                  <v-btn
                    id="action-more-caderno-servicos"
                    color="white"
                    class="ml-1"
                    height="22px"
                    width="22px"
                    fab
                    x-small
                    elevation="1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="canRunItem(item)"
                    @click="executarCadernoServicos(item.id)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-play
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Executar
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="canDeleteItem(item)"
                    @click="openDeleteDialog(item)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-trash-can-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Deletar
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="openDialogDetalhes(item)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-file-find-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Detalhes
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </base-material-card>

        <dialog-delete
          :show-dialog="dialogDelete"
          @changeValue="dialogDelete = $event"
          @deleteTriggered="deletarCadernoServicos(dialogDeleteData.id)"
        >
          <template slot="title">
            Deletar Caderno de Serviços #{{ dialogDeleteData.id }}
          </template>
          <template slot="body">
            Tem certeza que deseja deletar <strong>{{ dialogDeleteData.nome }}</strong>? 
          </template>
        </dialog-delete>
      </v-col>
    </v-row>

    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        />
      </template>
    </general-dialog-detalhes>
  </v-container>
</template>

<script>
import CadernoServicosService from '@/services/RelatorioCadernoServicosService';
import dayjs from 'dayjs';
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';
import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';
import pusherMixins from '@/mixins/pusherMixins';

export default {

  components: {
    DialogDelete: () => import('@/components/general/DialogDelete'),
    GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
    GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
    GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
  },
  
  mixins: [powerupsActionsMixins, DateFormatterMixins, pusherMixins],

  data() {
    return {
      powerupService: CadernoServicosService,
      powerupEntityName: 'Caderno_Servicos',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Usuário',
          value: 'usuario'
        },
        {
          text: 'Executado',
          value: 'executed'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      cadernos: [],
      search: '',
      dialogDelete: false,
      dialogDeleteData: { id: undefined, nome: undefined },
      downloadProgressData: {}
    };
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },

  mounted() {
    this.getAllCadernos();
    this.subscribe();
  },


  methods: {
    subscribe() {
      this.pusherChannel.bind('refreshCadernoServicos', () => {
        this.getAllCadernos();
      });
    },

    getAllCadernos() {
      CadernoServicosService.getAllCadernos()
        .then(response => {
          this.cadernos = [];
          response.data.cadernos.forEach(element => {
            this.cadernos.push({
              id: element.id,
              nome: element.nome,
              usuario: element.usuario.nome,
              usuario_id: element.usuario.id,
              created: element.created ? dayjs(element.created).format("DD/MM/YYYY HH:mm") : "-",
              executed: element.executado_em ? dayjs(element.executado_em).format("DD/MM/YYYY HH:mm") : "-",
              status: element.status,
              data_lancamento_inicio: element.data_lancamento_inicio, 
              data_lancamento_fim: element.data_lancamento_fim,
            });
          });
        })
        .catch(err => {
          console.log('Erro: ', err);
          this.$toast.error('Erro ao carregar relatórios de Caderno de Serviços.', '', { position: 'topRight' });
        });
    },

    openDeleteDialog(caderno) {
      this.dialogDeleteData = {
        id: caderno.id,
        nome: caderno.nome
      };

      this.dialogDelete = true;
    },

    deletarCadernoServicos(id) {
      
      this.dialogDelete = false;
      
      CadernoServicosService.excluirCadernoServicos(id)
        .then(() => {
          this.getAllCadernos();
          this.$toast.success('Caderno de Serviços excluído com sucesso.', '', { position: 'topRight' });
        })
        .catch(err => {
          this.$toast.error('Erro ao excluir o Caderno de Serviços.', '', { position: 'topRight' });
          console.log('Erro: ', err);
        });
    },

    executarCadernoServicos(id) {
      
      CadernoServicosService.executarCadernoServicos(id)
        .then(() => {
          this.$toast.info('Sua planilha será gerada em instantes. Por favor, aguarde.', '', { position: 'topRight', timeout: 2000 });
          this.getAllCadernos();
        })
        .catch(err => {
          this.$toast.error('Erro ao executar o Caderno de Serviços.', '', { position: 'topRight' });
          console.log('Erro: ', err);
        });
    },

    openDialogDetalhes(caderno) {     
        
      this.dialogDetalhesData = [
        {
          parametro: 'NOME:',
          valor: caderno.nome
        },
        {
          parametro: 'DATA DE LANÇAMENTO DE:',
          valor: this.formatDate(caderno.data_lancamento_inicio)
        },
        {
          parametro: 'DATA DE LANÇAMENTO ATÉ:',
          valor: this.formatDate(caderno.data_lancamento_fim)
        }
      ];

      this.dialogDetalhes = true;
    }

  }
};
</script>

<style>

@media screen and (min-width: 800px) {
  .caderno-servicos-table table tr td:nth-child(2) {
    max-width: 200px;
  }

  .caderno-servicos-table table tr td:nth-child(7),
  .caderno-servicos-table table tr td:nth-child(8) {
    white-space: nowrap !important;
  }
}

@media screen and (max-width: 480px) {
  .bs-caderno-servicos {
    width: 235.86px !important;
  }
}

.swithInterna label {
  font-size: 13px !important;
  margin-left: 0px !important;
}

</style>